import React from "react";
import { BASE_URL } from "../../constants";

const NextGenAI = () => {
  return (
    <>
      <div className="next-gen-ai-container">
        {/* First Row */}
        <div className="row" style={{ marginTop: "169px" }}>
          <div className="right-heading">
            Powered by <br />
            <span className="genaiheading"> NEXT Gen Ai</span>
            <img
              src={`${BASE_URL}common-images/mask_image.png
            `}
              alt="Mask"
              className="mask-image"
            />
          </div>
          <div className="left-text">
            Dsider's advanced AI capabilities transform complex energy sector
            analysis into actionable insights. Our platform integrates
            specialized AI agents, a comprehensive knowledge engine, and
            intuitive no-code building blocks to streamline decision-making
            across the energy value chain.
          </div>
        </div>

        {/* Second Row */}
        <div className="row">
          <div className="left-image">
            <img
              src={`${BASE_URL}technology/ai_agents.png`}
              alt="AI Agents"
              className="aiagents-image"
            />
          </div>
          <div className="right-content">
            <h2 className="ai-agents-heading ">Specialized AI Agents</h2>
            <p className="ai-agents-text my-n5">
              Purpose-built AI agents for technical analysis, economic modeling,
              and carbon assessment, working together to solve complex energy
              problems.
            </p>
          </div>
        </div>

        {/* Rectangle */}
        <div className="rectangle"></div>
      </div>

      <div className="next-gen-ai-container">
        {/* First Row */}
        <div className="row">
          <div className="right-heading"></div>
          <div className="left-text"></div>
        </div>

        {/* Second Row */}
        <div className="row">
          <div className="right-content">
            <h2 className="ai-engine-heading">AI Knowledge Engine</h2>
            <p className="ai-engine-text">
              Continuously learning system that accumulates technical knowledge,
              market data, and best practices to power more accurate predictions
              and recommendations.
            </p>
          </div>
          <div className="left-image">
            <img
              src={`${BASE_URL}technology/ai_engines.png`}
              alt="AI engine"
              className="aiblock-image"
            />
          </div>
        </div>
      </div>

      <div className="next-gen-ai-container">
        {/* First Row */}
        <div className="row">
          <div className="right-heading"></div>
          <div className="left-text"></div>
        </div>

        {/* Second Row */}
        <div className="row">
          <div className="left-image">
            <img
              alt="AI Agents"
              src={`${BASE_URL}technology/ai_blocks.png`}
              className="aiengine-image"
            />
          </div>
          <div className="right-content">
            <h2 className="ai-block-heading ">No-Code AI Building Blocks</h2>
            <p className="ai-block-text">
              Intuitive drag-and-drop interface with AI-powered
              <br />
              components for building complex models without
              <br />
              programming experience.
            </p>
          </div>
        </div>

        {/* Rectangle */}
        <div className="rectangle3"></div>
      </div>
    </>
  );
};

export default NextGenAI;
